import {Layer} from '../Layer.js';
import {Animate} from '../Animate.js';
import {RadarLayer} from '../layers/Radar.js';
import Library from '../Library.js';

export class RadarsLayer extends Layer {
    layers = [];
    labels = [];
    animate = undefined;

    constructor( map, settings = {} ){
        if( settings.name == undefined ) settings['name'] = "radars";
        if( settings.type == undefined ) settings['type'] = "rad_win";
        if( settings.num_images == undefined ) settings['num_images'] = 7;
        if( settings.offset == undefined ) settings['offset'] = 10;
        if( settings.opacity == undefined ) settings['opacity'] = 0.75;
        settings["dynamic_time"] = true;
        super( map, settings );
        for( let i = 0; i < this.settings['num_images']; i++ ){
            settings['offset'] = (this.settings['num_images'] - i - 1)*this.settings['offset'];
            settings['name'] = "radar-"+i;
            this.layers[i] = new RadarLayer( map, settings );
            this.map.addLayer( this.layers[i] );
            this.layers[i].layer.setVisible(true);
            this.setLabel( i );
            if( i == this.active_layer )
                this.layers[i].setOpacity( this.settings['opacity'] );
            else
                this.layers[i].setOpacity( 0. );
        }
        this.animate = new Animate( this.layers, this.labels, settings );
    }

    refresh(){
        super.refresh();
    }

    async setLabel(ind){
        let url = new URL( this.map.server + "/cgi-bin/image/radar.php" );
        url.searchParams.set( "type", this.settings['type']);
        url.searchParams.set( "output", "label" );
        url.searchParams.set( "format", "full" );
        url.searchParams.set( "frame", ind );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs - (this.settings['num_images'] - ind -1)*this.settings['offset']*60 ));
        let response = await fetch( url.toString());
        let text = await response.text();
        console.info( ind, text );
        this.labels[ind] = text.split("=")[1];
    }

    increment(val){
        this.animate.increment(val);
    }

    setLooping(val){
        this.animate.setLooping(val);
        if( val ) this.animate();
    }

    setOpacity(val){
        this.settings['opacity'] = Number(val);
        this.animate.setOpacity(this.settings['opacity']);
    }

    setType(val){
        for( let i = 0; i < this.layers.length; i++ ){
            this.layers[i].setType( val );
        }
        this.settings['type'] = val;
    }

    setVisible( val ){
        let vis = val;
        if( val == undefined )
            vis = this.layers[0].layer.isVisible()? false: true;
        for( let i = 0; i < this.layers.length; i++ ){
            this.layers[i].setVisible( val );
        }
        this.settings['visible'] = vis;
        return this.settings['visible'];
    }

    updateTime(){
        for( let i = 0; i < this.settings['num_images']; i++ ){
            this.setLabel( i );
        }
        this.refresh();
    }
}
